// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".g-terms-list[data-v-14444e0c]{margin-top:10px}.g-terms-list[data-v-14444e0c]:first-child{margin-top:0}.g-terms-list li[data-v-14444e0c]{display:flex;justify-content:space-between;align-items:center;padding:12px 6px;color:#666;border-bottom:1px solid #f1f3f7}.g-terms-list li a[data-v-14444e0c]{font-size:14px}.g-terms-list li i[data-v-14444e0c]{font-size:9px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
